export default __webpack_public_path__ + "static/slash-dark-mode-75a4e506ec4c03162c165bbed0129473.mp4";